import { createAction } from "../../utils/redux/createAction";
import { UPDATE_INTRODUCTION_DATA } from './types';
import { IIntroductionState, IAction } from "../../ts/redux";

export function updateIntroductionData(payload: IIntroductionState): IAction {
    return createAction(UPDATE_INTRODUCTION_DATA, payload);
}